module.exports = __webpack_public_path__ + "img/verified.615e727d.jpg";